export default {"src":"/_next/static/media/buyer-protection.c1a774ca.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};